import Moment from 'moment'
import { formatCounty } from '../../../common/helpers'

export const scrollTo = (key) => {
  const elem = document.querySelectorAll(`[data-topic="${key}"]`)[0]
  if (!elem) {
    return false
  }

  const startY = window.scrollY
  const endY = elem.offsetTop
  let startTime = null
  let current = startY
  const duration = 500

  const scrollStep = (timestamp) => {
    if (!startTime) {
      startTime = timestamp
    }
    if (timestamp - startTime >= duration) {
      current = endY
    } else {
      current = (endY - startY) * ((timestamp - startTime) / duration) + startY
    }
    if (Math.abs(current - endY) < 1) {
      current = endY
    }
    window.scrollTo(0, current)
    if (current !== endY) {
      window.requestAnimationFrame(scrollStep)
    }
  }

  window.requestAnimationFrame(scrollStep)
  return true
}

export const getContext = (location, activeJurisdiction) => {
  if (!location || !location.relatedJurisdictions) {
    return {}
  }

  const jurisdictionType = activeJurisdiction ? activeJurisdiction.standard.jurisdiction.type : location.wages.standard.jurisdiction.type.toLowerCase()
  const jurisdiction = activeJurisdiction || location.relatedJurisdictions[jurisdictionType]
  const jurisdictionTopics = buildOrderedTopicsAndSubTopics(jurisdiction.topics)
  const jurisdictionList = buildJurisdictionList(location)

  return {
    jurisdictionTopics,
    jurisdiction,
    jurisdictionType,
    jurisdictionList
  }
}

const buildJurisdictionList = function ({ relatedJurisdictions }) {
  const jurisdictionList = []
  if (relatedJurisdictions) {
    if (relatedJurisdictions.city && relatedJurisdictions.city.standard) {
      jurisdictionList.push({
        key: 'city',
        name: `${relatedJurisdictions.city.standard.jurisdiction.name} - City`
      })
    }
    if (relatedJurisdictions.county && relatedJurisdictions.county.standard) {
      jurisdictionList.push({
        key: 'county',
        name: `${formatCounty(relatedJurisdictions.county.standard.jurisdiction.name)} - County`
      })
    }
    if (relatedJurisdictions.state) {
      jurisdictionList.push({
        key: 'state',
        name: `${relatedJurisdictions.state.standard.jurisdiction.name} - State`
      })
    }
    if (relatedJurisdictions.federal) {
      jurisdictionList.push({
        key: 'federal',
        name: 'Federal'
      })
    }
  }

  return jurisdictionList
}

export const buildOrderedTopicsAndSubTopics = function (jurisdictionTopics) {
  if (!jurisdictionTopics) {
    // eject! we don't have any topics or subtopics to order!
    return {}
  }

  const unordered = {}

  jurisdictionTopics.forEach((topic) => {
    const topicTitle = (topic && topic.title) ? topic.title : ''

    if (topic && topic.subTopics && topic.subTopics.length > 0) {
      topic.subTopics.forEach((subTopic) => {
        const subTopicTitle = (subTopic && subTopic.title) ? subTopic.title : ''

        // TODO: Our code should not break based on the titles of the topics and subtopics
        if (topicTitle === 'Wage Rate' && subTopicTitle === 'Wage Rate') {
          return
        }
        if (topicTitle === 'Gratuities' && subTopicTitle === 'Tipped Minimum Wage') {
          return
        }

        if (!unordered[topicTitle]) {
          unordered[topicTitle] = {}
        }

        // support the scenario where the same topic and subtopic pair already exist in the document
        let contentBlocks = (unordered[topicTitle][subTopicTitle]) ? unordered[topicTitle][subTopicTitle].contentBlocks : []
        if (subTopic.contentBlocks && subTopic.contentBlocks.length > 0) {
          contentBlocks = contentBlocks.concat(subTopic.contentBlocks)
        }

        unordered[topicTitle][subTopicTitle] = { topic: topicTitle, subTopic: subTopicTitle, contentBlocks }
      })
    } else {
      // yep, this is weird, the old code did the same thing but using undefined instead of ""
      if (!unordered[topicTitle]) {
        unordered[topicTitle] = {}
      }
      unordered[topicTitle][''] = { topic: topicTitle, subTopic: '', contentBlocks: [] }
    }
  })

  const ordered = {}
  Object.keys(unordered)
    .sort((a, b) => {
      // Sort Wage Rate and Gratuities to the top
      if (a === 'Wage Rate') {
        return -1
      }
      if (b === 'Wage Rate') {
        return 1
      }

      if (a === 'Gratuities') {
        return -1
      }

      if (b === 'Gratuities') {
        return 1
      }

      if (a < b) {
        return -1
      }
      if (a > b) {
        return 1
      }
      return 0
    })
    .forEach((key) => {
      ordered[key] = unordered[key]
    })
  return ordered
}

export const filterTippedCreditAmount = (stateCode, contentBlocks) => {
  const now = new Date()
  let filteredItems = []

  filteredItems = contentBlocks.filter((item) => {
    // it is effective if it doesn't have an effective date or if that date is in the past
    const isEffective = !item.effectiveDate || Moment(item.effectiveDate).isBefore(now)
    // it has expired if it has an expiration date and that date is in the past
    const notExpired = !item.expirationDate || Moment(item.expirationDate).isAfter(now)

    return isEffective && notExpired
  })

  return filteredItems
}
